import { SANDBOX_PREDEFINED_VALUES, assertsValidSandbox } from '../constant';

import { getAttributeArray, getAttributeFromArray } from './attrs';

export const SANDBOX_DELIMITER = ' ';

export const getSandbox = (sandbox: string | undefined) => {
    if (!sandbox) {
        return getAttributeFromArray(SANDBOX_PREDEFINED_VALUES, SANDBOX_DELIMITER);
    }

    const allowArr = getAttributeArray(sandbox, assertsValidSandbox, SANDBOX_DELIMITER);

    return getAttributeFromArray([...allowArr, ...SANDBOX_PREDEFINED_VALUES], SANDBOX_DELIMITER);
};

export const sandboxTestUtils = {
    isSandboxIncludesPredefinedValues: (sandbox: string) =>
        SANDBOX_PREDEFINED_VALUES.every((val) => sandbox.includes(val)),
};
